import * as React from "react";
import styled from "styled-components";
import { HESPListItem } from "../Landing/SignUpComplete";

interface Props {
    text: string;
    icon: React.ReactNode;
    onClick: () => void;
    selected?: boolean;
}

const ItemWrapper = styled.div`
    margin-bottom: 5px;
    cursor: pointer;
    padding-bottom: 3px;
    padding-top: 10px;
    padding-left: 10px;
    width: 100%;

    &:hover {
        background-color: #dfe3e8;
    }
`;

const ItemText = styled.div.attrs((props: { selected: boolean }) => ({
    selected: props.selected,
}))`
    color: ${(props) => (props.selected ? "black" : "#5c5c5c")};
    font-weight: ${(props) => (props.selected ? 600 : 500)};
    font-size: 15px;
    margin-left: 20px;
`;

function SidebarItem({ text, icon, onClick, selected }: Props) {
    return (
        <ItemWrapper onClick={onClick}>
            <HESPListItem>
                {icon}
                <ItemText selected={selected}>{text}</ItemText>
            </HESPListItem>
        </ItemWrapper>
    );
}

export default SidebarItem;
